/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import * as Sentry from '@sentry/browser';
import { put, call, select } from 'redux-saga/effects';

import { FETCH_STACKED_PULL_REQUESTS_COUNT } from 'src/redux/pull-request/merge-reducer';
import { getPullRequestApis } from 'src/sagas/helpers';

import {
  getCurrentPullRequestUrlPieces,
  getPullRequestBranchName,
} from '../selectors';

export function* fetchStackedPullRequestsCountSaga() {
  const api = yield* getPullRequestApis();
  const { owner, slug } = yield select(getCurrentPullRequestUrlPieces);
  const branch: string = yield select(getPullRequestBranchName);
  try {
    yield put({ type: FETCH_STACKED_PULL_REQUESTS_COUNT.REQUEST });
    // @ts-ignore
    const stackedPrCount = yield call(
      api.getStackedPullRequestsCount,
      owner,
      slug,
      branch
    );
    yield put({
      type: FETCH_STACKED_PULL_REQUESTS_COUNT.SUCCESS,
      payload: stackedPrCount,
    });
  } catch (e) {
    Sentry.captureException(e);
    yield put({
      type: FETCH_STACKED_PULL_REQUESTS_COUNT.ERROR,
      payload: e.message,
    });
  }
}
